var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{ref:"vimeoplayer",attrs:{"id":"vimeoplayer","width":"100%","height":"100%","src":_vm.uri,"frameborder":"0","allow":"autoplay; fullscreen","allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }